// NPM imports
import React from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { GRID } from "../../../../constants";

// Destructuring
const { PRICING_METHODS } = GRID;

export default function QtyNotifier(props) {
  const { editable, isPopUp, readOnly, rowMeta, value } = props;
  let toolTipText = "";

  function _isEditable() {
    return (isPopUp && readOnly) || (!readOnly && editable);
  }

  if (isPopUp) {
    if (
      rowMeta &&
      rowMeta.pricingData &&
      !rowMeta.pricingData.value &&
      rowMeta.pricingData.type !== PRICING_METHODS.NON_LINEAR &&
      rowMeta.pricingData.type !== PRICING_METHODS.DIY_PRICING
    ) {
      toolTipText = "Quantity is a Range. Please click to edit this";
    } else if (
      rowMeta &&
      rowMeta.pricingData &&
      rowMeta.pricingData.value &&
      rowMeta.pricingData.isAdhoc
    ) {
      toolTipText =
        "This is an ad-hoc SKU. Click here to enter effort for resources";
    }
    return (
      <Tooltip placement="top" overlay={<div>{toolTipText}</div>}>
        <div
          className={`rs-cell ${_isEditable() ? "is-editable" : ""}`}
          onClick={() => _isEditable() && props.onClick()}
          onKeyPress={() => null}
          role="button"
          tabIndex="0">
          {value}
          <span className="dealtablefeild-edit">
            <FontAwesomeIcon icon={["far", "tilde"]} />
          </span>
        </div>
      </Tooltip>
    );
  }
  return (
    <div
      className={`rs-cell ${_isEditable() ? "is-editable" : ""}`}
      onClick={() => _isEditable() && props.onClick()}
      onKeyPress={() => null}
      role="button"
      tabIndex="0">
      {value}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Display/Renderer/QtyNotifier.js